"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyConstants = void 0;
/**
 * Grid property constants
 */
class PropertyConstants {
}
exports.PropertyConstants = PropertyConstants;
/**
 * Property part divider
 */
PropertyConstants.PROPERTY_DIVIDER = '.';
/**
 * Grid
 */
PropertyConstants.GRID = 'grid';
/**
 * Labeler
 */
PropertyConstants.LABELER = 'labeler';
/**
 * Grids
 */
PropertyConstants.GRIDS = 'grids';
/**
 * Propagate
 */
PropertyConstants.PROPAGATE = 'propagate';
/**
 * Width
 */
PropertyConstants.WIDTH = 'width';
/**
 * Text Size
 */
PropertyConstants.TEXT_SIZE = 'text_size';
/**
 * Buffer
 */
PropertyConstants.BUFFER = 'buffer';
/**
 * Enabled
 */
PropertyConstants.ENABLED = 'enabled';
/**
 * Min Zoom
 */
PropertyConstants.MIN_ZOOM = 'min_zoom';
/**
 * Max Zoom
 */
PropertyConstants.MAX_ZOOM = 'max_zoom';
/**
 * Color
 */
PropertyConstants.COLOR = 'color';
/**
 * Lines
 */
PropertyConstants.LINES = 'lines';
//# sourceMappingURL=PropertyConstants.js.map